var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from "aurelia-framework";
import { WorkflowAssignmentsService } from "../../../services/workflow/workflow-assignments-service";
import { WorkflowStateEnum } from "../../../models/workflow/workflow.models";
import * as Enumerable from "linq";
import { transient, autoinject } from "aurelia-dependency-injection";
import { UserClientService } from "../../../services/authentication/user-client.service";
import { NotificationClientService, NotificationType } from "../../../services/basics/notification-client.service";
import { computedFrom } from "aurelia-binding";
import { I18N } from "aurelia-i18n";
import { DialogClientService } from "../../../services/basics/dialog-client.service";
import { UserClaimsService } from "../../../services/authentication/user-claims.service";
import { BaseClaims } from "../../../constants/authentication/base-claims";
import { DialogServiceConstants } from "../../../constants/basics/dialog.constants";
require.context("../../../views/plugins/workflow-activities", true, /\.html$/);
require.context("../../../views/plugins/workflow-activities", true, /\.ts$/);
var WorkflowForEntity = /** @class */ (function () {
    function WorkflowForEntity(workflowAssignmentsService, userClientService, userClaimsService, dialogClientService, notificationClientService, i18N) {
        var _this = this;
        this.workflowAssignmentsService = workflowAssignmentsService;
        this.userClientService = userClientService;
        this.userClaimsService = userClaimsService;
        this.dialogClientService = dialogClientService;
        this.notificationClientService = notificationClientService;
        this.i18N = i18N;
        this.workflowFlagUpdater = {};
        this.completedComposeArray = [];
        this.upcomingComposeArray = [];
        this.title = this.i18N.tr('workflow-text');
        this.model = null;
        this.reload = function (workflowState) {
            _this.workflowState = workflowState;
            _this.workflowState.workflowAssignments = _this.workflowState.workflowAssignments;
        };
        this.user = this.userClientService.currentUser;
        this.canTakeOwnership = this.userClaimsService.hasPermission(BaseClaims.CanTakeOwnership);
    }
    Object.defineProperty(WorkflowForEntity.prototype, "showButtons", {
        get: function () {
            return this.workflowState && this.currentAssignment && this.user &&
                ((!this.workflowState.workflowCancellationReasonId &&
                    this.user.departmentId == this.currentAssignment.actionTakerDepartmentId &&
                    !this.currentAssignment.actionTakerId) || (!this.workflowState.workflowCancellationReasonId
                    && this.currentAssignment.actionTakerId == this.user.id && this.user.departmentId == this.currentAssignment.actionTakerDepartmentId)
                    || (this.canTakeOwnership && this.currentAssignment.actionTakerId != this.user.id));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkflowForEntity.prototype, "completed", {
        get: function () {
            if (!this.workflowState)
                return [];
            var currentStep = this.getCurrentStep();
            return Enumerable.from(this.workflowState.workflowAssignments)
                .where(function (x) { return !x.isCurrentAssignment && (currentStep == null || x.stepNumber < currentStep); })
                .orderBy(function (x) { return x.stepNumber; })
                .toArray();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkflowForEntity.prototype, "isCancelled", {
        get: function () {
            return this.currentWorkflowState == WorkflowStateEnum.Cancelled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkflowForEntity.prototype, "isCompleted", {
        get: function () {
            return this.currentWorkflowState == WorkflowStateEnum.Completed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkflowForEntity.prototype, "currentWorkflowState", {
        get: function () {
            if (!this.workflowState)
                return;
            return this.workflowState.state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkflowForEntity.prototype, "current", {
        get: function () {
            var _this = this;
            if (!this.workflowState)
                return [];
            return Enumerable.from(this.workflowState.workflowAssignments)
                .where(function (x) { return x.stepNumber == _this.getCurrentStep(); })
                .orderBy(function (x) { return x.stepNumber; })
                .toArray();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkflowForEntity.prototype, "currentAssignment", {
        get: function () {
            if (!this.workflowState)
                return null;
            return this.current[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkflowForEntity.prototype, "upcoming", {
        get: function () {
            if (!this.workflowState)
                return [];
            var currentStep = this.getCurrentStep();
            return Enumerable.from(this.workflowState.workflowAssignments)
                .where(function (x) { return !x.isCurrentAssignment && currentStep != null && x.stepNumber > currentStep; })
                .orderBy(function (x) { return x.stepNumber; })
                .toArray();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkflowForEntity.prototype, "perviousStepWasIncomplete", {
        get: function () {
            var _this = this;
            if (!this.workflowState)
                return false;
            return Enumerable.from(this.workflowState.workflowAssignments)
                .where(function (x) { return x.stepNumber == _this.getCurrentStep() - 1; })
                .orderBy(function (x) { return x.stepNumber; })
                .any(function (x) { return !x.isAccepted; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkflowForEntity.prototype, "showTakeOwnershipButton", {
        get: function () {
            if (this.workflowState.workflowCancellationReasonId) {
                return false; // canceled workflow can't be assigned
            }
            else if (!this.currentAssignment) {
                return false; // if no current assignment then no need for take ownership
            }
            else if (this.currentAssignment.executedByExternalInboundApi) {
                return false; // for 'executedByExternalInboundApi' no need for any user activity since its depend on API confirmation
            }
            else if (this.user.departmentId != this.currentAssignment.actionTakerDepartmentId) {
                return false; // user department and workflow current department is different; can't take ownership on another department
            }
            else if (this.canTakeOwnership && this.currentAssignment.actionTakerId != this.user.id) {
                return true; // if workflow is already assigned to someone, then if the user has 'canTakeOwnership' claim then allow to take ownership
            }
            else if (!this.currentAssignment.actionTakerId) {
                return true; // if workflow is not assigned then allow to take ownership
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkflowForEntity.prototype, "showCancelWorkflowButton", {
        get: function () {
            if (this.workflowState.workflowCancellationReasonId) {
                return false; // workflow is already canceled
            }
            else if (this.currentAssignment.actionTakerDepartmentId != this.user.departmentId) {
                return false; // user department and workflow current department is different; can't take ownership on another department
            }
            else if (this.currentAssignment.actionTakerId == this.user.id) {
                return true; // only current workflow assigned user can cancel the workflow
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    WorkflowForEntity.prototype.propertyChanged = function () {
        this.bind();
    };
    WorkflowForEntity.prototype.getCurrentStep = function () {
        var current = Enumerable.from(this.workflowState.workflowAssignments)
            .where(function (x) { return x.isCurrentAssignment; })
            .select(function (x) { return x.stepNumber; });
        return current.any() ? current.min() : null;
    };
    WorkflowForEntity.prototype.bind = function () {
        var _this = this;
        if (this.entityId && this.entityTypeId) {
            this.workflowAssignmentsService
                .getWorkflowState(this.entityId, this.entityTypeId)
                .then(function (x) {
                _this.workflowState = x.workflowState;
                _this.workflowState.workflowAssignments = x.workflowState.workflowAssignments;
                _this.entityType = x.entityType;
            });
        }
    };
    WorkflowForEntity.prototype.getMeta = function (assignment) {
        var model = JSON.parse(assignment.meta);
        return model ? model : {};
    };
    WorkflowForEntity.prototype.asJson = function (meta) {
        if (meta) {
            var obj = JSON.parse(meta);
            return obj ? obj : {};
        }
        return {};
    };
    WorkflowForEntity.prototype.takeOwnership = function () {
        var _this = this;
        require("../../../../../ClientApp/app/views/app/admin/dialogs/confirmation-dialog");
        var confirmModel = {
            headerTitle: "confirmation-title",
            headerMessage: "confirmation-take-ownership-text",
            btnOkayText: "confirm-text",
            btnNoText: "cancel-text",
        };
        this.dialogClientService.show(DialogServiceConstants.URLs.ConfirmationDialog, {
            confirmModel: confirmModel,
            save: function () { return new Promise(function (resolve, reject) {
                _this.workflowAssignmentsService
                    .takeOwnership(_this.currentAssignment.workflowAssignmentId)
                    .then(function (response) {
                    _this.dialogClientService.hide();
                    _this.reload(response.workflowState);
                    _this.notificationClientService.show(_this.i18N.tr('ownership-taken-text'), _this.i18N.tr('workflow-has-been-assigned-to-you-text'), NotificationType.Success);
                    _this.updateWorkflowAssignments();
                    resolve();
                }).catch(function (x) {
                    _this.dialogClientService.hide();
                    _this.notificationClientService.show(_this.i18N.tr('ownership-has-been-taken-text'), _this.i18N.tr('workflow-activity-has-not-been-assigned-to-you-text'), NotificationType.Error);
                    reject();
                });
            }); }
        }, undefined, undefined, undefined, undefined, false);
    };
    WorkflowForEntity.prototype.cancelWorkflow = function () {
        var _this = this;
        if (!window["SystemJS"]) {
            require("" + "app/views/components/workflow-for-entity/dialogs/workflow-cancellation-dialog");
        }
        this.dialogClientService.show("app/views/components/workflow-for-entity/dialogs/workflow-cancellation-dialog", {
            title: this.i18N.tr('workflow-text'),
            cancel: function () {
                _this.dialogClientService.hide();
            },
            submit: function (cancellationReasonId, isReject, cancellationNotes) {
                _this.dialogClientService.hide();
                _this.workflowAssignmentsService
                    .cancelWorkflow(_this.workflowState.workflowStateId, cancellationReasonId, cancellationNotes)
                    .then(function (x) {
                    _this.notificationClientService.show(_this.i18N.tr("success"), _this.i18N.tr("workflow-canceled-success-text"), NotificationType.Success);
                    _this.reload(x.workflowState);
                });
            }
        });
    };
    WorkflowForEntity.prototype.updateWorkflowAssignments = function () {
        if (this.workflowFlagUpdater) {
            this.workflowFlagUpdater = null;
        }
        else {
            this.workflowFlagUpdater = {};
        }
    };
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], WorkflowForEntity.prototype, "entityId", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], WorkflowForEntity.prototype, "entityTypeId", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], WorkflowForEntity.prototype, "title", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], WorkflowForEntity.prototype, "model", void 0);
    __decorate([
        computedFrom('workflowState'),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], WorkflowForEntity.prototype, "completed", null);
    __decorate([
        computedFrom('workflowState.state'),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], WorkflowForEntity.prototype, "currentWorkflowState", null);
    __decorate([
        computedFrom('workflowState', 'workflowFlagUpdater'),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], WorkflowForEntity.prototype, "current", null);
    __decorate([
        computedFrom('workflowState', 'workflowFlagUpdater'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], WorkflowForEntity.prototype, "currentAssignment", null);
    __decorate([
        computedFrom('workflowState', 'workflowFlagUpdater'),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], WorkflowForEntity.prototype, "upcoming", null);
    __decorate([
        computedFrom('workflowState', 'workflowFlagUpdater'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], WorkflowForEntity.prototype, "perviousStepWasIncomplete", null);
    __decorate([
        computedFrom('workflowState.workflowCancellationReasonId', 'user.id', 'user.departmentId', 'currentAssignment.actionTakerDepartmentId', 'currentAssignment.actionTakerId', 'canTakeOwnership'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], WorkflowForEntity.prototype, "showTakeOwnershipButton", null);
    __decorate([
        computedFrom('workflowState.workflowCancellationReasonId', 'user.id', 'user.departmentId', 'currentAssignment.actionTakerDepartmentId', 'currentAssignment.actionTakerId'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], WorkflowForEntity.prototype, "showCancelWorkflowButton", null);
    WorkflowForEntity = __decorate([
        autoinject(),
        transient(),
        __metadata("design:paramtypes", [WorkflowAssignmentsService,
            UserClientService,
            UserClaimsService,
            DialogClientService,
            NotificationClientService,
            I18N])
    ], WorkflowForEntity);
    return WorkflowForEntity;
}());
export { WorkflowForEntity };
